module.exports = __webpack_public_path__ + "static/img/li-panl-icon.733daf8d.png";